import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ITestimonial } from "../testimonialModel";

export const getAllTestimonial = createAsyncThunk(
  "Testimonial/FindAllTestimonial",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Testimonial/FindAllTestimonial`,
        {
          CustomerName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Testimonial:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createTestimonial = createAsyncThunk(
  "Testimonial/InsertTestimonial",
  async (TestimonialData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Testimonial/InsertTestimonial`,
        TestimonialData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Testimonial:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateTestimonial = createAsyncThunk(
  "Testimonial/UpdateTestimonial",
  async (TestimonialData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Testimonial/UpdateTestimonial`,
        TestimonialData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Testimonial:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteTestimonial = createAsyncThunk(
  "Testimonial/DeleteTestimonial",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Testimonial/DeleteTestimonial`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Testimonial :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getTestimonialByID = createAsyncThunk(
  "Testimonial/FindByIDTestimonial",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Testimonial/FindByIDTestimonial`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        CustomerName: result.CustomerName,
        TestimonialImage: result.TestimonialImage,
        Description: result.Description,
        IsActive: result.IsActive ? 1 : 2,
      } as ITestimonial;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Certificate :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveTestimonial = createAsyncThunk(
  "Testimonial/FindAllActiveTestimonial",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Testimonial/FindAllActiveTestimonial`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Certificate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveTestimonial = createAsyncThunk(
  "Testimonial/ActiveInActiveTestimonial",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Testimonial/ActiveInActiveTestimonial`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Testimonial :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const TestimonialImageUpload = createAsyncThunk(
  "Testimonial/TestimonialImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Testimonial/TestimonialImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Testimonial Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
